import React, { useEffect } from "react"
import { useTranslation } from "react-i18next"

function PPErrorDisplay({ error }) {
    const { t } = useTranslation()

    useEffect(() => {
        if (error) {
            console.error(error)
        }
    }, [error])

    return (
        <div className="alert alert-danger">
            <h3>
                <i className="icon fas fa-ban" /> {t("errors.display_title")}
            </h3>
            <p className="mb-0">{t("errors.display_hint")}</p>
        </div>
    )
}

export default PPErrorDisplay
